import {
    Box,
    Checkbox,
    FormControlLabel,
    Tooltip,
    Typography,
    SxProps,
    Theme,
} from '@mui/material'
import { Info } from '@mui/icons-material'
import { ChangeEvent, ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface IRealTimeAlertEventsCheckboxProps {
    checked: boolean
    onChange: (e: ChangeEvent<HTMLInputElement>) => void
    sx?: SxProps<Theme>
    disabled?: boolean
}

const RealTimeAlertEventsCheckbox = (
    props: IRealTimeAlertEventsCheckboxProps,
): ReactElement => {
    const { checked, onChange, sx, disabled } = props
    const { t } = useTranslation()

    return (
        <Tooltip title={t('realTimeAlertEventsTooltip')} placement="top" arrow>
            <Box component="span" sx={{ display: 'inline-flex' }}>
                <FormControlLabel
                    control={
                        <Checkbox
                            size="small"
                            checked={checked}
                            onChange={onChange}
                            disabled={disabled}
                        />
                    }
                    label={
                        <Box display="flex" alignItems="center" gap={0.5}>
                            <Typography variant="body1">
                                {t('includeRealTimeAlertEvents')}
                            </Typography>
                            <Info
                                sx={{
                                    fontSize: '18px',
                                    color: '#747474',
                                }}
                            />
                        </Box>
                    }
                    sx={sx}
                    disabled={disabled}
                />
            </Box>
        </Tooltip>
    )
}

export default RealTimeAlertEventsCheckbox
